/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import UIConstants from "../../UIConstants";
import { environment } from "../environment";

// Hier darf kein ApiClient/HttpClient benutzt werden, da sonst eine zirkuläre Referenz entsteht
const requestUrl = `${environment.sysBaseUrl}/appinsights/ladeconnectionstring`;
const requestInit: RequestInit = { credentials: UIConstants.credentials, method: "GET" };
export default class ConnectionStringLoader {
    public async ladeConnectionString(): Promise<string | null> {
        let result: string | null = null;

        const resp = await fetch(requestUrl, requestInit);
        if (this.hasContent(resp)) {
            result = await resp.text();
        }

        return result;
    }

    private hasContent(response: Response): boolean {
        return response.status !== 204;
    }
}
